import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";

import { TextInput, TextInputProps } from "~/ui";

type ChangeEventType = ChangeEvent<HTMLInputElement>;
type TextInputValueType = TextInputProps["value"];

type DebouncedTextInputProps = TextInputProps & {
  wait: number;
};
/**
 * Not for URL-backed search bars — use useDebouncedSavedQuery + plain TextInput.
 * Fine for local form/modal filter fields.
 */
export const DebouncedTextInput = (props: DebouncedTextInputProps) => {
  const { wait, onChange, value: propsValue, ...rest } = props;
  const [innerValue, setInnerValue] = useState<TextInputValueType>("");
  const handle = useRef<number>();

  const cancel = () => window.clearTimeout(handle.current);

  const innerOnChange = useCallback(
    (e: ChangeEventType) => {
      cancel();
      setInnerValue(e.currentTarget.value);
      handle.current = window.setTimeout((e: ChangeEventType) => onChange?.(e), wait, e);
    },
    [onChange, wait],
  );

  useEffect(() => {
    setInnerValue(propsValue);
    return cancel;
  }, [propsValue]);

  return <TextInput {...rest} value={innerValue} onChange={innerOnChange} />;
};
